<template>
  <!-- <v-container fluid 
  v-if="user.role == 'c4e091b9-1b89-477e-b7a2-2b37750c84e1'"
  > -->
  <v-container fluid>
    <!-- <v-row align="center">
      <v-progress-circular
        indeterminate
        v-if="loading"
        class="my-orange mx-auto"
      ></v-progress-circular>
    </v-row> -->

    <v-tabs v-model="activeTab" background-color="transparent" color="#F15A24">
      <v-tab>Importar/Atualizar</v-tab>
      <v-tab>Alterar ordem</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <!-- IMPORTAR/ATUALIZAR -->
      <v-tab-item>
        <v-row
          justify="center"
          align="center"
          class="mt-2"
          style="
            position: sticky;
            top: 0px;
            background-color: rgb(255, 255, 255);
            z-index: 5;
            box-shadow: 0px 4px 7px -4px rgba(0, 0, 0, 0.5);
          "
        >
          <v-col cols="12">
            <v-select
              v-model="searchType"
              :items="['URL/Número da Lei', 'Intervalo de datas']"
              label="Tipo de busca"
              variant="outlined"
              color="#F15A24"
              class="mb-4"
            ></v-select>

            <v-text-field
              v-if="searchType === 'URL/Número da Lei'"
              variant="outlined"
              class="mt-3"
              color="#F15A24"
              @change="currentPage = 1"
              v-model="importSearch"
              label="Buscar usando URL ou número da lei"
            >
            </v-text-field>

            <v-row v-if="searchType === 'Intervalo de datas'">
              <v-col cols="12" sm="6">
                <v-text-field
                  prepend-icon="mdi-calendar"
                  v-model="dateinit"
                  color="#F15A24"
                  label="Data inicial"
                  placeholder="dd/mm/aaaa"
                  maxlength="10"
                  :error-messages="
                    !isValidDate(dateinit) && dateinit ? 'Data inválida' : ''
                  "
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  prepend-icon="mdi-calendar"
                  v-model="dateend"
                  label="Data final"
                  color="#F15A24"
                  placeholder="dd/mm/aaaa"
                  maxlength="10"
                  :error-messages="
                    !isValidDate(dateend) && dateend ? 'Data inválida' : ''
                  "
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-col cols="12" class="d-flex justify-center">
              <v-btn :loading="loading" @click="buscarLeis" color="#F15A24" dark>Buscar</v-btn>
            </v-col>
          </v-col>
        </v-row>

        <v-row v-if="legislacoes.length > 0 && openDialog">
          <v-col cols="12">
            <v-list two-line>
              <v-subheader>
                <div
                  class="d-flex justify-space-between align-center"
                  style="width: 100%"
                >
                  <div class="d-flex align-center">
                    <v-checkbox
                      v-model="selectAll"
                      @change="toggleSelectAll"
                      color="#F15A24"
                      class="mr-2"
                    ></v-checkbox>
                    <span>Legislações ({{ totalLegislacoes }} resultados)</span>
                  </div>
                  <v-btn
                    :loading="loadingCrawler"
                    @click="executeCrawler"
                    color="#F15A24"
                    dark
                  >
                    Atualizar
                  </v-btn>
                </div>
              </v-subheader>

              <template v-for="item in legislacoes">
                <v-list-item :key="item.id_lei">
                  <v-checkbox
                    v-model="item.selected"
                    @change="handleSelection"
                    color="#F15A24"
                    class="mr-2"
                  ></v-checkbox>
                  <v-list-item-content>
                    <v-list-item-title class="d-flex align-center">
                      <span
                        v-html="highlight(item.numero_lei, importSearch)"
                      ></span>
                      <v-chip
                        v-if="!item.url"
                        color="warning"
                        small
                        class="ml-2"
                      >
                        Sem URL
                      </v-chip>
                    </v-list-item-title>

                    <v-list-item-subtitle
                      v-html="highlight(item.nome_lei, importSearch)"
                    ></v-list-item-subtitle>

                    <v-expand-transition>
                      <div v-if="item.editingUrl" class="mt-2">
                        <v-form
                          class="mt-2 d-flex justify-space-between"
                          @submit.prevent="atualizarUrl(item)"
                        >
                          <v-text-field
                            v-model="item.newUrl"
                            class="flex-grow-1 mr-4"
                            color="#F15A24"
                            label="Digite a URL da legislação"
                            placeholder="https://..."
                            dense
                            :rules="[(v) => !!v || 'URL é obrigatória']"
                            hint="Insira a URL completa
                            da legislação"
                            persistent-hint
                          ></v-text-field>

                          <div class="d-flex">
                            <v-btn
                              small
                              dark
                              color="#F15A24"
                              @click="atualizarUrl(item)"
                              :loading="item.loading"
                              class="mr-2"
                            >
                              Salvar
                            </v-btn>
                            <v-btn
                              small
                              dark
                              color="#F15A24"
                              @click="item.editingUrl = false"
                            >
                              Cancelar
                            </v-btn>
                          </div>
                        </v-form>
                      </div>
                    </v-expand-transition>
                  </v-list-item-content>

                  <v-list-item-action class="d-flex flex-column align-center">
                    <v-btn
                      v-if="!item.editingUrl"
                      small
                      text
                      color="#F15A24"
                      @click="
                        item.editingUrl = true;
                        item.newUrl = item.url;
                      "
                    >
                      <v-icon left>mdi-pencil</v-icon>
                      Editar URL
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="`div-${item.id_lei}`"></v-divider>
              </template>
            </v-list>

            <v-pagination
              v-model="currentPage"
              :length="totalPages"
              :total-visible="7"
              @input="handlePageChange"
              color="#F15A24"
              class="mt-4"
            ></v-pagination>
          </v-col>
        </v-row>

        <v-snackbar
          v-model="snackbar.show"
          :color="snackbar.color"
          :timeout="4000"
        >
          {{ snackbar.text }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar.show = false">
              Fechar
            </v-btn>
          </template>
        </v-snackbar>
      </v-tab-item>

      <!-- ALTERAR ORDEM -->
      <v-tab-item>
        <v-row
          class="mt-2"
          justify="center"
          align="center"
          style="
            position: sticky;
            top: 0px;
            background-color: rgb(255, 255, 255);
            z-index: 5;
            box-shadow: 0px 4px 7px -4px rgba(0, 0, 0, 0.5);
          "
        >
          <v-col cols="12" class="d-flex flex-row align-center">
            <v-autocomplete
              clearable
              :filter="customFilter"
              :items="legislacoes"
              :search-input.sync="search"
              :loading="loading"
              solo
              v-model="strSearchLegiscao"
              item-text="nome_lei"
              item-value="id_lei"
              color="#F15A24"
              outlined
              class="mx-auto py-1 d-flex align-center justify-center"
              style="background-color: transparent; border-radius: 100px"
              placeholder="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
              hint="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
              hide-details
              label="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title>
                    Pesquise pelo número ou palavra da ementa da
                    <strong>legislação</strong>
                  </v-list-item-title>
                </v-list-item>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content style="max-width: 60%">
                  <v-list-item-title
                    v-html="highlight(item.numero_lei, search)"
                  ></v-list-item-title>
                  <div
                    class="text--primary mb-4"
                    v-html="highlight(item.nome_lei, search)"
                  ></div>
                </v-list-item-content>
                <v-list-item-action> </v-list-item-action>
              </template>
            </v-autocomplete>
            <v-btn class="ml-3" color="#F15A24" dark>Nova Legislação</v-btn>
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="d-flex align-center w-100 justify-space-between"
          >
            <h2 class="my-orange gt-bold mb-0">{{ lei.numero_lei }}</h2>
            <p style="font-weight: bold">
              {{ lei.status_lei ? "PUBLICADO" : "RASCUNHO" }}
            </p>
          </v-col>

          <v-col cols="12" md="12">
            <p class="font-weight-light">{{ lei.nome_lei }}</p>
          </v-col>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn class="mr-2" small
              ><v-icon>mdi-plus</v-icon>Novo Conteudo</v-btn
            >
            <v-btn @click="salvarLei" small
              ><v-icon>mdi-content-save</v-icon>Salvar Lei</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <DynamicScroller
              id="conteudos"
              ref="conteudos"
              class="scroller"
              :items="conteudos"
              key-field="id_reg"
              :min-item-size="54"
            >
              <template v-slot:default="{ item, index, active }">
                <DynamicScrollerItem
                  :item="item"
                  :data-index="index"
                  :active="active"
                  :size-dependencies="[item.conteudo]"
                >
                  <v-col class="rowAnnotation" cols="12">
                    <p v-html="item.conteudo" :id="item.id_reg"></p>
                    <div>
                      <p class="d-flex justify-end">
                        Registro #<b>{{ item.id_reg }}</b> <br />
                      </p>
                      <p class="d-flex align-center justify-end">
                        Posicão
                        <v-text-field
                          color="#F15A24"
                          style="max-width: 80px"
                          class="ml-3"
                          v-model="index"
                          :disabled="!item.edit"
                        ></v-text-field>
                        <v-icon
                          v-if="!item.edit"
                          @click="
                            item.edit = true;
                            item.sort = index;
                          "
                          >mdi-pencil</v-icon
                        >
                        <v-icon
                          v-if="item.edit"
                          color="#F15A24"
                          @click="
                            saveItem(item, index);
                            item.edit = false;
                          "
                          >mdi-check</v-icon
                        >
                      </p>
                    </div>
                  </v-col>
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-row>
      <v-col>
        <label class="tag-sm mx-1" v-for="(t, i) in lei.tags" :key="i">
          <input type="checkbox" disabled class="tag-sm-checkbox" />
          <span class="tag-sm-container">
            <span class="tag-sm-content">
              <span>{{ t }}</span>
              <span class="tag-sm-icon"></span>
            </span>
          </span>
        </label>
      </v-col>
    </v-row>
    <!-- <v-row>
			<v-col>
				<p class="font-weight-light">
					Fonte:
					<span class="my-orange"> {{ lei.esfera_lei }}</span>
				</p>
			</v-col>
		</v-row>
		<v-divider
			class="my-5 mb-7"
			color="#f57029"
		></v-divider> -->

    <v-dialog width="700px" v-model="showBusca">
      <v-card class="px-5">
        <v-card-title class="px-0"
          >Busca interna - {{ buscaModel }} <v-spacer />
          <v-btn @click="showBusca = false" text
            ><v-icon large>mdi-close</v-icon></v-btn
          ></v-card-title
        >
        <v-card-text>
          <p v-for="l in resultadoBusca" :key="l.id_reg">
            {{ l.conteudo }}
            <v-btn @click="gotoRef(l.id_reg)" text color="#f15a24"
              >Ir até
              <v-icon color="#f15a24" small>mdi-arrow-down-right</v-icon></v-btn
            >
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirm" width="25vw">
      <v-card>
        <v-card-title> Remover Anotação </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <h2 style="gap: 1rem; color: #f15a24">
                <v-icon>mdi-account-trash</v-icon>Você tem certeza que deseja
                remover está anotação ?<br />
                <small class="black--text text-caption"
                  >Obs: Está ação é irreversível.
                </small>
              </h2>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="confirm = false"> Cancelar </v-btn>

          <v-btn
            color="#F15A24"
            :loading="loadingDelete"
            @click="deleteAnnotation()"
            dark
          >
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style scoped>
.scroller {
  height: 800px;
  overflow-y: auto;
  /* border: 2px dashed rgba(132, 8, 8, 0.406); */
}

#map {
  position: fixed;
  top: 110px;
  right: 0;
  width: 80px;
  min-width: 80px;
  height: 100%;
  z-index: 100;
}

a {
  color: #f15a24;
}

.rowHovered {
  /* border-radius: 2px; */
  /* border: 1px solid #f15a24; */
  cursor: pointer;
  background-color: #f7f7f7;
}

.annotation {
  background-color: #f15a2405;
  /* border: 1px dashed #f15a24; */
}

.rowAnnotation:hover {
  cursor: pointer;
  background-color: #f7f7f7;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}

.annotation ::v-deep iframe {
  height: 250px;
}

.annotation p {
  margin-bottom: 0px !important;
}
</style>
<script>
// import pagemap from "pagemap";
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

export default {
  name: "Crawler",
  components: { DynamicScroller, DynamicScrollerItem },
  data() {
    return {
      legislacoes: [],
      strSearchLegiscao: "",
      search: "",
      idAnotacao: "",
      panel: [],
      isActive: false,
      files: [],
      annotation: { status: "private", texto: "" },
      delAnnotation: {},
      annotationVisible: "",
      anotacoes: [],
      showBusca: false,
      resultadoBusca: [],
      dateinit: "",
      searchType: "URL/Número da Lei",
      date: "",
      date2: "",
      dateend: "",
      openDialog: true,
      confirm: false,
      openMenu: false,
      openMenu2: false,
      buscaModel: "",
      showNewAnnotation: false,
      conteudoSelected: {},
      conteudos: [],
      importSearch: "",
      currentPage: 1,
      itemsPerPage: 10,
      totalLegislacoes: 0,
      totalPages: 0,
      comentarios: {},
      avatar: {},
      comentario: "",
      selectAll: false,
      selectedLegislacoes: [],
      selectedUrls: {},
      idLei: 0,
      loadingCrawler: false,
      loading: false,
      snackbar: {
        show: false,
        text: "",
        color: "success",
      },
      loadingNewAnnotation: false,
      loadingDelete: false,
      lei: {},
      activeTab: 0,

      statusAnnotation: [
        { text: "Público", value: "published" },
        { text: "Grupo", value: "group" },
        { text: "Privado", value: "private" },
        { text: "Apenas Amigos", value: "friend" },
        { text: "Arquivado", value: "archived" },
      ],
      customToolbar: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],

        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
      customToolbar1: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        // [{ header: "1" }, { header: "2" }, "blockquote"],

        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],

        ["clean"],
      ],
    };
  },
  async created() {
    // this.loadLegislacoes();
    this.idLei = this.$route.params.idLei;
    if (this.idLei) {
      this.loadLei();
    }
  },
  watch: {
    strSearchLegiscao(nValue) {
      if (nValue) {
        this.idLei = nValue;
        this.loadLei();
      }
    },
    dateinit(value) {
      this.dateinit = this.applyDateMask(value);
    },
    dateend(value) {
      this.dateend = this.applyDateMask(value);
    },
  },
  mounted() {
    // if (this.user.role != "c4e091b9-1b89-477e-b7a2-2b37750c84e1")
    //   this.$router.push("/painel/legislacoes");
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    allSelected() {
      return (
        this.legislacoes.length > 0 &&
        this.legislacoes.every((item) => item.selected)
      );
    },
    someSelected() {
      return this.selectedLegislacoes.length > 0;
    },
    groups() {
      return this.$store.state.user.grupos;
    },
    editor() {
      return this.$refs.editor.quill;
    },
    intBreakPoint() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 0;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 4;
        default:
          return 0;
      }
    },
  },
  methods: {
    async salvarLei() {
      let conteudosSort = this.conteudos.map((e, i) => ({
        id_reg: e.id_reg,
        sort: i,
      }));
      await this.$http.patch(`/items/leis/${this.idLei}`, {
        conteudo: {
          update: conteudosSort,
        },
      });
      this.loadLei();
    },
    async atualizarUrl(item) {
      if (!item.newUrl) {
        this.showMessage("A URL é obrigatória", "error");
        return;
      }

      if (!/^https?:\/\//i.test(item.newUrl)) {
        item.newUrl = "https://" + item.newUrl;
      }

      try {
        const date = new Date();
        item.loading = true;
        const payload = {
          url: item.newUrl,
          data_atualizacao: date,
        };
        if (!item.data_criacao) {
          payload.data_criacao = date;
        }

        await this.$http.patch(`items/leis/${item.id_lei}`, payload);

        item.url = item.newUrl;
        item.editingUrl = false;
        item.loading = false;

        this.showMessage("URL atualizada com sucesso!", "success");
        await this.buscarLeis();
      } catch (error) {
        window.console.error("Erro ao atualizar URL:", error);
        this.showMessage("Erro ao atualizar URL. Tente novamente.", "error");
        item.loading = false;
      }
    },

    async toggleSelectAll() {
      try {
        const query = this.mountQuery();

        const { data } = await this.$http.get(
          `items/leis${query}&limit=-1&fields=id_lei,url`
        );

        const allItems = data.data.map((item) => ({
          id: item.id_lei,
          url: item.url,
        }));

        const allSelected = allItems.every((item) =>
          this.selectedLegislacoes.includes(item.id)
        );

        if (!allSelected) {
          this.selectedLegislacoes = allItems.map((item) => item.id);
          this.selectedUrls = allItems.reduce((acc, item) => {
            if (item.url) {
              acc[item.id] = item.url;
            }
            return acc;
          }, {});

          this.legislacoes.forEach((item) => {
            item.selected = true;
          });
        } else {
          this.selectedLegislacoes = [];
          this.selectedUrls = {};

          this.legislacoes.forEach((item) => {
            item.selected = false;
          });
        }

        this.selectAll = !allSelected;
      } catch (error) {
        window.console.error(error);
        this.showMessage("Erro ao selecionar todas as legislações.", "error");
      }
    },

    handleSelection() {
      this.legislacoes.forEach((item) => {
        const index = this.selectedLegislacoes.indexOf(item.id_lei);
        if (item.selected && index === -1) {
          this.selectedLegislacoes.push(item.id_lei);
        } else if (!item.selected && index !== -1) {
          this.selectedLegislacoes.splice(index, 1);
        }
      });
    },

    applyDateMask(value) {
      if (!value) return "";

      value = value.replace(/\D/g, "");

      if (value.length <= 2) {
        return value;
      } else if (value.length <= 4) {
        return value.substr(0, 2) + "/" + value.substr(2);
      } else {
        return (
          value.substr(0, 2) +
          "/" +
          value.substr(2, 2) +
          "/" +
          value.substr(4, 4)
        );
      }
    },

    convertDateToISO(dateString) {
      if (!this.isValidDate(dateString)) return null;
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },

    isValidDate(dateString) {
      if (!dateString || !/^\d{2}\/\d{2}\/\d{4}$/.test(dateString))
        return false;

      const [day, month, year] = dateString.split("/").map(Number);
      const date = new Date(year, month - 1, day);

      return (
        date instanceof Date &&
        !isNaN(date) &&
        date.getDate() === day &&
        date.getMonth() === month - 1 &&
        date.getFullYear() === year
      );
    },

    mountQuery() {
      let query = "";
      if (this.searchType === "URL/Número da Lei") {
        query = `?search=${this.importSearch}`;
      } else if (this.searchType === "Intervalo de datas") {
        // Valida e converte as datas
        const isoDateInit = this.convertDateToISO(this.dateinit);
        const isoDateEnd = this.convertDateToISO(this.dateend);

        if (!isoDateInit || !isoDateEnd) {
          return "";
        }

        const date1 = new Date(isoDateInit);
        date1.setHours(0, 0, 0, 0);

        const date2 = new Date(isoDateEnd);
        date2.setHours(23, 59, 59, 0);

        query =
          `?filter[_and][0][data_criacao][_between][0]=${date1.toISOString()}` +
          `&filter[_and][0][data_criacao][_between][1]=${date2.toISOString()}`;
      }

      return query;
    },
    async buscarLeis() {
      this.loading = true;
      try {
        const offset = (this.currentPage - 1) * this.itemsPerPage;
        const query = this.mountQuery();
        const countResponse = await this.$http.get(
          `items/leis${query}&aggregate[count]=id_lei`
        );
        const total = countResponse.data.data[0].count.id_lei;

        const { data } = await this.$http.get(
          `items/leis${query}&limit=${this.itemsPerPage}&offset=${offset}&sort=-data_criacao`
        );

        const addProps = (items) =>
          items.map((item) => ({
            ...item,
            editingUrl: false,
            newUrl: item.url || "",
            loading: false,
            selected: this.selectedLegislacoes.includes(item.id_lei),
          }));

        this.legislacoes = addProps(data.data);
        this.totalLegislacoes = total;
        this.totalPages = Math.ceil(total / this.itemsPerPage);
      } catch (error) {
        window.console.error(error);
      } finally {
        this.loading = false;
      }
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.buscarLeis();
    },
    showMessage(text, color = "success") {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    getSelectedCount() {
      return this.selectedLegislacoes.length;
    },
    async executeCrawler() {
      if (this.selectedLegislacoes.length === 0) {
        this.showMessage("Selecione pelo menos uma legislação", "error");
        return;
      }

      this.loadingCrawler = true;
      try {
        let urls;

        if (
          this.selectedUrls &&
          Object.keys(this.selectedUrls).length ===
            this.selectedLegislacoes.length
        ) {
          urls = this.selectedLegislacoes.map((id) => this.selectedUrls[id]);
        } else {
          const urlsPromises = this.selectedLegislacoes.map((id) =>
            this.$http
              .get(`items/leis/${id}`)
              .then((response) => response.data.data.url)
          );
          urls = await Promise.all(urlsPromises);
        }

        const validUrls = urls.filter((url) => url && url.trim() !== "");

        if (validUrls.length === 0) {
          this.showMessage(
            "Nenhuma URL válida encontrada nas legislações selecionadas",
            "error"
          );
          return;
        }

        const payload = {
          url_leis: validUrls,
        };

        window.console.log("Crawler payload:", payload);

        this.$http.post("crawler", payload);
        this.showMessage(
          "Crawler executado com sucesso em segundo plano, aguarde a finalizacão",
          "success"
        );
      } catch (error) {
        window.console.error("Erro ao executar crawler:", error);
        this.showMessage("Erro ao executar crawler. Tente novamente.", "error");
      } finally {
        this.loadingCrawler = false;
      }
    },
    saveItem(item, index) {
      // window.console.log({item,index})
      this.conteudos.splice(item.sort, 1);
      this.conteudos.splice(index, 0, item);
    },
    loadLei() {
      this.loading = true;
      this.$http({ url: "items/leis/" + this.idLei }).then((data) => {
        this.lei = data.data.data;
      });
      this.$http({
        url:
          "items/conteudoleis/?limit=-1&sort=sort,id_reg&filter[id_lei][_eq]=" +
          this.idLei,
      }).then((data) => {
        // window.console.log(data.data.data)
        this.conteudos = data.data.data;
        // this.reloadAnotacoes();
        // this.reloadComentarios();
        this.loading = false;
      });
    },
    async loadLegislacoes() {
      this.loading = true;
      let search = "";
      // this.strSearchLegiscao === undefined || this.strSearchLegiscao === null ? "" : `search:"${this.strSearchLegiscao}",`;
      const query = `query FilterByApelidosLeis {
                leis(${search} sort:["-data_lei"],
                        limit: 3000,
                        offset: 0) {
                    id_lei
                    numero_lei
                    data_lei
                    nome_lei
                }
                leis_aggregated${search === "" ? `` : `(${search})`} {
                    count { id_lei }
                }
            }`;
      // const variables = { user_id: this.user.id };
      const {
        data: { data },
      } = await this.$http.post("https://api.mylegis.com.br/graphql", {
        query,
        // variables,
      });
      this.legislacoes = data.leis;
      this.loading = false;
      // window.console.log(data.leis)
    },
    customFilter(item, queryText) {
      if (
        queryText.length > 4 &&
        !isNaN(queryText) &&
        queryText.indexOf(".") == -1
      ) {
        queryText = queryText.replace(/(\d)(?=(\d{3})+$)/g, "$1.");
        this.search = queryText.replace(/(\d)(?=(\d{3})+$)/g, "$1.");
      }
      const textOne = item.nome_lei.toLowerCase();
      const textTwo = item.numero_lei.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },

    gotoRef(refName) {
      var position = refName - this.conteudos[0].id_reg;
      // window.console.log(refName)
      // // var top = document.getElementById(refName);
      // window.console.log({refName, position})
      // window.console.log(this.conteudos[0].id_reg)
      // window.console.log(this.$refs )

      // this.$refs.conteudos.$el.scrollTo({ top: position * 100, behavior: "smooth" })
      this.$refs.conteudos.scrollToItem(position);
      this.showBusca = false;
      window.scrollTo({ top: 200, behavior: "smooth" });
    },

    buscarLei() {
      this.$http
        .get(
          `items/conteudoleis/?search=` +
            this.buscaModel +
            `&filter[id_lei][_eq]=` +
            this.idLei
        )
        .then((res) => {
          this.resultadoBusca = res.data.data;
          this.showBusca = true;
        });
    },

    highlight(content, query) {
      if (!content) return "";
      if (!query) {
        return content;
      }
      return content.replace(new RegExp(query, "gi"), (match) => {
        return '<span class="my-orange">' + match + "</span>";
      });
    },
  },
};
</script>
